import { useLocation } from "react-router";
import { useSelector } from "src/store";
import { selectHasValidSession } from "src/store/auth";

export function useWithVisibleNavigation() {
    const { pathname } = useLocation();
    const hasValidSession = useSelector(selectHasValidSession);

    // Visitors without a usable session are on their way to the login flow (see AuthGuard), so the
    // navigation must stay hidden until they come back — otherwise the dashboard chrome flashes up
    // for as long as the redirect takes to prepare.
    if (!hasValidSession) {
        return false;
    }

    // The index paths redirect into the dashboard. Hiding the navigation on them would make Drawer switch element
    // trees on arrival, remounting the router and sending every startup request a second time.
    if (pathname === "/" || pathname === "/dashboard") {
        return true;
    }

    const included = ["/account/", "/dashboard/", "/admin/", "/clients/"];
    const excluded = ["/account/confirm", "/account/recover", "/account/reset"];

    const isExcluded = excluded.some((path) => pathname.startsWith(path));
    if (isExcluded) {
        return false;
    }
    return included.some((path) => pathname.startsWith(path));
}
